<template>
    <b-tab>
        <template v-slot:title>
            <i class="cus-page-white-lightning"></i>Template
        </template>
        <b-card-text>
            <letter-content
                :letterDetails="letterDetails"
                :isLetterLocked="isLetterLocked"
                @content-saved="contentSaved"
                @detail-saved="detailSaved"
                @letter-status="$emit('letter-status', $event)"
            ></letter-content>
        </b-card-text>
    </b-tab>
</template>
<script>
export default {
    components: {
        LetterContent: () =>
            import("@/components/patient-letter/letter-content")
    },
    props: {
        letterDetails: {
            type: Object
        },
        isLetterLocked: {
            type: Boolean
        }
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {
        contentSaved() {
            this.$emit("content-saved");
        },
        detailSaved(details) {
            this.$emit("detail-saved", details);
        }
    }
};
</script>
